import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import ErrorPagesNotFound, {
	LazyNotFoundErrorPage,
} from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { errorsNotFoundRoute } from '@atlassian/jira-router-routes-errors-not-found-routes/src/errorsNotFoundRoute.tsx';

export const errorsNotFoundRouteEntry = createEntry(errorsNotFoundRoute, () => ({
	group: 'errors',
	component: ErrorPagesNotFound,
	layout: globalLayout,
	resources: [...getNavigationResources()],
	forPaint: [LazyAtlassianNavigation, LazyNotFoundErrorPage],
}));
